import DefaultAvatar from './DefaultAvatar';
import DefaultAvatarF from './DefaultAvatarF';
import DefaultAvatarFO from './DefaultAvatarFO';
import DefaultAvatarMO from './DefaultAvatarMO';
import DefaultAvatarM from './DefaultAvatarM';
import DefaultAvatarO from './DefaultAvatarO';
export var defaultAvatarSets = {
    default: DefaultAvatar,
    female: DefaultAvatarF,
    male: DefaultAvatarM,
    femaleOutline: DefaultAvatarFO,
    maleOutLine: DefaultAvatarMO,
    outline: DefaultAvatarO,
};
//# sourceMappingURL=index.js.map